import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgIcon0003Home3({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 1 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path d="M.5 12a.498.498 0 01-.37-.835l8.829-9.758c.274-.303.644-.47 1.042-.47.397 0 .767.167 1.042.47l8.829 9.758a.5.5 0 01-.741.671l-8.829-9.758c-.082-.091-.189-.141-.3-.141s-.218.05-.3.141L.873 11.836a.5.5 0 01-.371.165z" />
      <path d="M15.5 20h-4a.5.5 0 01-.5-.5V16H9v3.5a.5.5 0 01-.5.5h-4c-.827 0-1.5-.673-1.5-1.5v-8a.5.5 0 011 0v8a.5.5 0 00.5.5H8v-3.5a.5.5 0 01.5-.5h3a.5.5 0 01.5.5V19h3.5a.5.5 0 00.5-.5v-8a.5.5 0 011 0v8c0 .827-.673 1.5-1.5 1.5z" />
    </svg>
  );
}
export default SvgIcon0003Home3;
